import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        name: 'integrations-index',
        path: '/integrations',
        component: () => import('@/pages/integrations/IntegrationsIndex.vue'),
        redirect: { name: 'integrationstable-index' },
        meta: {
            title: 'Integrations',
            middleware: [GateKeeperMiddleware],
        },
        children: [
            {
                path: '',
                name: 'integrationstable-index',
                component: () => import('@/pages/integrations/IntegrationsTable.vue'),
                meta: {
                    middleware: [GateKeeperMiddleware],
                },
            },
            {
                path: ':integrationId(\\d+)',
                name: 'integration-index',
                component: () => import('@/pages/integrations/IntegrationsView.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                },
            },
        ],
    },
];
